module.exports = __webpack_public_path__ + "static/img/16.8caa02b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/16.png
// module id = QTVT
// module chunks = 0